/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterSupplierDto
 */
export interface RegisterSupplierDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterSupplierDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterSupplierDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterSupplierDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterSupplierDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterSupplierDto
     */
    password: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterSupplierDto
     */
    organizationId?: number;
}

/**
 * Check if a given object implements the RegisterSupplierDto interface.
 */
export function instanceOfRegisterSupplierDto(value: object): value is RegisterSupplierDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function RegisterSupplierDtoFromJSON(json: any): RegisterSupplierDto {
    return RegisterSupplierDtoFromJSONTyped(json, false);
}

export function RegisterSupplierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterSupplierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'password': json['password'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function RegisterSupplierDtoToJSON(value?: RegisterSupplierDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'organizationId': value['organizationId'],
    };
}

